export default {
    TASKLISTGET: 'task:listGet', //  获取任务列表
    PAGETOTAL: 'task:pageTotal', //list页码
    LISTLOADING: 'task:listLoading', // 获取loading状态
    GETTASKID: 'task:getTaskId', //获取任务id
    GETPARENTID: 'task:getParentId', //获取parentid
    GETROOT: 'task:getRoot', //获取root
    GETTASK: 'task:gettask',//存task
    ADDSHOW: 'task:addShow', //显示新增弹窗
    EDITSHOW: 'task:editShow', //显示编辑弹窗
    ADDTYPE: 'task:addType', //新增类型
    EDITINFO: 'task:editInfo', //要修改的信息
    EDITIME: 'task:editTime', //要修改的时间
    EDITOVERFLOW: 'task:editOverflow', //要修改的溢出
    EDITTASKTYPE: 'task:editTaskType',//要修改的任务类型
    EDITIPREUSEDTIMES: 'task:editIpReusedTimes', //要修改的利用次数
    EDITANDROIDRATIO: 'task : androidRatio',//要修改的安卓比率
    EDITWAITTIMEOUT: 'task:editWaitTimeout', //要修改的等待时长
    EDITPROVINCE:'task:editprovince',//要修改的省份列表
    PROVINCELINST: 'task:provinceList',//省份列表
    TASKSOURCE: 'task:tasksource', //任务来源
    TRACKDELAYTIME: 'task:trackDelayTime', //追踪延迟时间
    TIMEPAIRS: 'task:timePairs',//执行时间段
    TASKPOSITION: 'task:taskposition',
    PRIMRYSCRIPT: 'task: primaryScript',
    OTHERSCRIPT: 'task: otherScript',
    GETPV: 'task: getPv',//获取Pv
    RESETPVSHOW: 'task: resetPv',//显示重置弹窗
    TASKID: 'task: taskId',//存放传递到弹层中的taskID
    TASKIDLIST: 'task: taskIdList',//存放传递到弹层中taskIdList
    BULKUPDATETASK: 'task: bulkupdatetask',//显示批量更新弹层
    CLUSTERLINST: 'task: clusterList',//集群列表
    OUTTASKCATEGORYLIST: 'task: outTaskCategoryList',//外部任务分类列表
    GROUPLIST: 'task: groupList',//用户组列表
    AGENTS: 'task: agents',
    AREAS: 'task: areas',
    LABELLINST: 'task: label',//标签信息
    MONITERNAMELIST: 'task: moniternamelist',//检测公司信息
    CURVELINST: 'task: curve',//曲线信息
    EDITENGINE: 'task: engine',//引擎
    MAINSCRIPT: 'task: mainScriptPath',//主脚本地址
    SCRIPT: 'task: scriptPath',//脚本地址
    EDITPVTOUVRATIO: 'task: pvToUvRatio',//Uv占比
    EDITFORCEWAIT: 'task: forceWait', //强制等待
    SCREENSHOTSHOW:'task: screen', //截图状态
    PRINTTASKITEMDATA:'task : TaskItemData',//截图项任务数据
    CHANGE: 'task: changeEditInfo',
    USERLIST:'task : userList',//用户列表
    SHOWAPI: 'task: showApi', // 显示隐藏api弹窗
    APIURL: 'task: apiUrl', // 获取到的api的地址
    TASKLOGS: 'task: tasklogs', // 获取某个任务的修改记录
    SHOWMODAL: 'task: showModal', // 显示隐藏的modal
    HIDEMODAL: 'task: hideModal', // 隐藏显示的modal
    SHOWDETAIL: 'task: showDetail', // 显示隐藏的时间线详情
    HIDEDETAIL: 'task: hideDetail', // 隐藏像是的时间线详情
    TASKLOGBYINDEX: 'task: tasklogByIndex', // 获取一条任务日志
    SHOWTASKNOTE: 'task: showTaskNote',//显示任务备注
    HIDETASKNOTE: 'task: hideTaskNote',//隐藏任务备注
    TASKNOTE: 'task: taskNote',//任务备注
    TASKNOTEUPDATE: 'task: taskNote:update',//更新任务备注
    TASKNOTEADD: 'task: taskNote:add',//添加任务属性
    TASKOVERFLOWSTATU: 'task:overflow:status',//任务溢出属性设置显示框状态
    TASKOVERFLODINGSTATU: 'task:overflow:loading',
    ACCOUNTLIST: 'task:accountlist',//账号列表
};



// WEBPACK FOOTER //
// ./pages/task/tasklist/constant.js